<div class="settings" *ngIf="isStop">
  <p [style.fontSize.px]="localFontSize">
    {{ 'blindreading.fontSize' | translate : { fontSize: localFontSize } }}
  </p>
  <input type="range" min="14" max="70" [(ngModel)]="localFontSize" />
</div>
<button msGameButton color="orange" *ngIf="isStop" (click)="play()">{{ 'blindreading.start' | translate }}</button>

<div *ngIf="!isStop" class="game">
  <div class="wrap">
    <div class="words" #overlay>
      <div class="blind" [style.height.px]="blindHeight" #blind></div>

      <div class="words-container" [style.top.px]="wordsWrapToTop" #wordsWrap>
        <p
          [style.fontSize.px]="localFontSize"
          [style.lineHeight.px]="localFontSize * 1.5"
          *ngFor="let word of words"
        >
          {{ word }}
        </p>
      </div>
    </div>
  </div>

  <div class="buttons" *ngIf="isPlay">
    <button msGameButton color="orange" class="button" (click)="stop()">{{ 'blindreading.stop' | translate }}</button>
  </div>
</div>
